import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import history from 'src/history';
import { basename } from 'src/config';

ReactDOM.render(
  <Router basename={basename} history={history}>
    <App />
  </Router>,
  document.getElementById('root')
);
